/**
 * ユーザー関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const TaskState = Record({
  id: null,
  title: '',
  description: '',
  status: 'open',
  reservation_id: null
})

export { TaskState }
